var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attachments.length > 0)?_c('div',{class:("component__post__gallery " + _vm.amountClass)},[_c('vue-picture-swipe',{staticClass:"article__gallery",attrs:{"items":_vm.formaAttachedtImages(_vm.attachments),"options":{
      bgOpacity: 0.9,
      shareEl: false,
      fullscreenEl: false,
      history: false,
      maxSpreadZoom: 3,
      getDoubleTapZoom: function (isMouseClick, item) { // execute on picture click
        if(isMouseClick) { // is mouse click on image or zoom icon
          // Set up two zoom levels:
          if(!item.zoomLevel) { item.zoomLevel = item.initialZoomLevel }

          item.zoomLevel =  item.zoomLevel < 1 ? 1 :
                            item.zoomLevel < 2 ? 2 :
                            item.initialZoomLevel

          return item.zoomLevel
        } else { // is double-tap
          // zoom to original if initial zoom is less than 0.7x,
          // otherwise to 1.5x, to make sure that double-tap gesture always zooms image
          return item.initialZoomLevel < 0.7 ? 1 : 1.5
        }
      }
    }}}),_c('div',{staticClass:"article__gallery__content"},[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }